import axios from "axios";
import { BASE_URL } from "../utils/constants";

const API_URL = BASE_URL;

const login = async (data) => {
  try {
    const response = await axios.post(`${API_URL}usesr/Login`, data);
    if (response.data) {
      localStorage.setItem("token", response.data.token);
      localStorage.setItem("user", JSON.stringify(response.data.user));
      return response.data;
    }
    throw new Error("Invalid response from server");
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

const forgotPassword = async (data) => {
  try {
    const response = await axios.post(`${API_URL}forgot/password`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
};

const AuthService = {
  login,
  logout,
  forgotPassword,
};

export default AuthService;
